import script from "./AnnounceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnounceCard.vue?vue&type=script&setup=true&lang=js"

import "./AnnounceCard.vue?vue&type=style&index=0&id=5f6be394&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6be394"]])

export default __exports__